var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M173 983L173 1011",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 173.5,
    cy: 978.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M168.987 978.19C168.987 974.283 172.288 971.117 176.358 971.117C176.943 971.117 177.511 971.184 178.056 971.308C176.742 970.48 175.187 970 173.519 970C168.814 970 165 973.806 165 978.5C165 983.194 168.814 987 173.519 987C175.814 987 177.895 986.093 179.427 984.62C178.492 985.032 177.454 985.263 176.358 985.263C172.288 985.263 168.987 982.096 168.987 978.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M182.402 977.6L182.37 975.146L180.536 976.719L178.304 976.056L179.112 978.337L177.765 980.381L180.1 980.218L181.499 982.144L182.133 979.763L184.345 978.909L182.402 977.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch4);
export default __webpack_public_path__ + "static/media/church_4.816c69421d28859b43a600bca8f15902.svg";
export { ForwardRef as ReactComponent };